export const UPDATE_GENERAL_ERROR = 'UPDATE_GENERAL_ERROR';
export const UPDATE_GENERAL_PENDING = 'UPDATE_GENERAL_PENDING';
export const UPDATE_GENERAL_SUCCESS = 'UPDATE_GENERAL_SUCCESS';

export const GET_GENERAL_ERROR = 'GET_GENERAL_ERROR';
export const GET_GENERAL_PENDING = 'GET_GENERAL_PENDING';
export const GET_GENERAL_SUCCESS = 'GET_GENERAL_SUCCESS';

export const CLEAN_CURRENT_GENERAL_SETTINGS_PROJECT = 'CLEAN_CURRENT_GENERAL_SETTINGS_PROJECT';